export default "__VITE_ASSET__ZOtTiFdU__"